// Module
var code = "<div class=\"app app-header-fixed\" id=\"app\" ui-view=\"app-content\">\n\n</div>\n<div load-spinner spinner-name=\"mainSpinner\"></div>\n";
// Exports
module.exports = code;